import React from 'react';
import about from '../img/about.jpg';
import Typewriter from 'typewriter-effect';
import pdf from '../img/Ali_Haydar(Resume).pdf'

function ImageSection() {
    return (
        <div className="ImageSection">
            <div className="img">
                <img style={{ width: '100%' }} src={about} alt="" />
            </div>
            <div className="about-info">
                <h4>I am<span><Typewriter
                    options={{
                        strings: ['Ali Haydar'],
                        autoStart: true,
                        loop: true,
                    }}
                /></span></h4>
                <p className="about-text" style={{ textAlign: 'justify' }}>
                    I am a Full-Stack Web Developer. I try to develop the front end of a web application using React.js
                    and the back-end using Node.js with comfortable. I am always ready to learn any new technology. I am
                    excited to be joining your company to enhance your company name and reputation day by day.
                </p>
                <div className="about-details">
                    <div className="left-section">
                        <p>Full Name</p>
                        <p>Age</p>
                        <p>Nationality</p>
                        <p>Languages</p>
                        <p>Address</p>
                        <p>Email</p>
                        <p>Mobile</p>

                    </div>
                    <div className="right-section">
                        <p>: Ali Haydar</p>
                        <p>: 23</p>
                        <p>: Bangladeshi</p>
                        <p>: Bangla, English</p>
                        <p>: Fulgazi,Feni,Bangladesh</p>
                        <p>: alihaydar6599@gmail.com</p>
                        <p>: +8801854046599</p>

                    </div>
                </div>
                <button className="btn"><a href={pdf} style={{ textDecoration: 'none', color: 'white' }} download='Ali_Haydar(Resume).pdf' >Download Resume</a></button>
            </div>
        </div>
    )
}

export default ImageSection;
